// Mirrors the BE `NOTE_ATTACHMENT_PROCESSING_PAGE_LIMIT`. If BE moves, this
// must move — the optimistic stub's `pages_processed` would otherwise diverge
// from what the BE eventually upserts and confuse the monetization counter.
export const ATTACHMENT_PAGE_PROCESSING_LIMIT = 100;
